<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Solana Compta"
      title="Solana Compta"
    >
      <template slot="links">
        <sidebar-item :link="{name: 'Dashboard', icon: 'fa fa-chart-area text-green', path: '/dashboard'}" /> 
        <sidebar-item :link="{name: 'Factures', icon: 'fa fa-file-invoice text-blue', path: '/facture'}"/>
        <sidebar-item :link="{name: 'Fournisseurs', icon: 'fa fa-dolly text-orange', path: '/fournisseur'}"/>
        <sidebar-item :link="{name: 'Devises', icon: 'fa fa-euro-sign text-yellow', path: '/devise'}"/>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
</style>
